import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Button, CTA } from "../Generic";
import "./styles/index.scss";
import white_check from "../../assets/lottieJson/white_check.json";
import json_home from "../../assets/lottieJson/home.json";
import json_winery from "../../assets/lottieJson/winery.json";
import json_calendar from "../../assets/lottieJson/calendar.json";

import home_img from "../../assets/icons/menu_home.png";
import tank_img from "../../assets/icons/menu_tank.png";
import grape_img from "../../assets/icons/menu_grape.png";
import report_img from "../../assets/icons/menu_report.png";
import winery_img from "../../assets/icons/menu_winery.png";
import analysis_img from "../../assets/icons/menu_analysis.png";
import protocol_img from "../../assets/icons/menu_protocol.png";
import pressing_img from "../../assets/icons/menu_pressing.png";
import treatment_img from "../../assets/icons/menu_treatment.png";
import programming_img from "../../assets/icons/menu_agenda.png";

import useLabels from "../../hooks/useLabels";
import { selectUser, selectUsers } from "../../context/selectors";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { setUsers } from "../../context/users/usersSlice";
import { getUsers } from "../../services/utils";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getItem, setItem } from "../../services/LocalStorage";

const NavigationButtons = ({}) => {
  const navigate = useNavigate();

  return (
    <div className="sidebar_container_navigation">
      <Button
        isRed={true}
        arrowDirection="left"
        customClassName="sidebar_container_navigation_action"
        disabled={!window.navigation.canGoBack}
        onClick={() => navigate(-1)}
      />
      <Button
        isRed={true}
        customClassName="sidebar_container_navigation_action"
        disabled={!window.navigation.canGoForward}
        onClick={() => navigate(1)}
      />
    </div>
  );
};

const BurgerMenu = ({ setIsOpen, isOpen, setIsSecondaryOpen, isSecondaryOpen }) => {
  const location = useLocation();
  const [getLabel] = useLabels();
  const axiosPrivate = useAxiosPrivate();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const users = useSelector(selectUsers);
  const [permission, setPermissions] = useState({});
  
  useEffect(() => {
    if (!users || users.length === 0) {
        loadUsers();
    }
    const currentUser = user?.role < 3 ? 
      { settings: {permissions: {lots: true, tanks: true, protocols: true, wineries: true}} } :
      users?.find((u) => u?.username === user?.userName);
    setPermissions(currentUser?.settings?.permissions || {})
  }, [])

  const loadUsers = async () => {
    const currentUsers = await getUsers(axiosPrivate);
    dispatch(setUsers(currentUsers))
  }

  if (!isOpen) return;

  return (<>
    <div className="blocker" onClick={() => {if (!isSecondaryOpen) setIsOpen(false); setIsSecondaryOpen(false)}}></div>
    <div className={`burger_container ${isOpen ? 'open' : ''}`} onClick={() => isOpen && setIsOpen(false)}>
      <div className="burger_container_primary">
        {!isSecondaryOpen && <><NavLink to="/">
          <Button
            isRed={true}
            isFull={true}
            label={getLabel("homeNavLink")}
            customClassName="burger_container_action"
            isNavLink={true}
            isActive={location.pathname === "/"}
            disableIcon={true}
          />
        </NavLink>
        <NavLink to="/programming">
          <Button
            isRed={true}
            isFull={true}
            label={getLabel("programmingNavLink")}
            customClassName="burger_container_action"
            isNavLink={true}
            isActive={location.pathname === "/programming"}
            disableIcon={true}
          />
        </NavLink>
        {permission?.lots && <NavLink to="/lots">
          <Button
            isRed={true}
            isFull={true}
            label={getLabel("lotsNavLink")}
            customClassName="burger_container_action"
            isNavLink={true}
            isActive={location.pathname === "/lots"}
            disableIcon={true}
          />
        </NavLink>}
        {permission?.tanks && <NavLink to="/tanks">
          <Button
            isRed={true}
            isFull={true}
            label={getLabel("tanksNavLink")}
            customClassName="burger_container_action"
            disableIcon={true}
            isNavLink={true}
            isActive={location.pathname === "/tanks"}
          />
        </NavLink>}
        </>}
        {permission?.protocols && <div
          className="burger_container_secondary dropdown"
          onClick={(e) => { setIsSecondaryOpen(true); e.stopPropagation(); }}
          // style={{ marginTop: "32px" }}
        >
          {!isSecondaryOpen && <Button
            isRed={true}
            isFull={true}
            isNavLink={true}
            label={"Protocolli"}
            disableIcon={true}
            isActive={location.pathname.startsWith("/protocols")}
            customClassName='burger_container_action'
          />}
          {isSecondaryOpen && <div className="dropdown-secondary" onClick={() => isOpen && setIsOpen(false)}>
            <NavLink to="/protocols/analysis">
              <Button
                isRed={true}
                isFull={true}
                isNavLink={true}
                label={getLabel("protocolsAnalysisNavLink")}
                disableIcon={true}
                isActive={location.pathname === "/protocols/analysis"}
                customClassName="burger_container_action"
              />
            </NavLink>
            <NavLink to="/protocols/treatment">
              <Button
                isRed={true}
                isFull={true}
                isNavLink={true}
                label={getLabel("protocolsTreatmentNavLink")}
                disableIcon={true}
                isActive={location.pathname === "/protocols/treatment"}
                customClassName="burger_container_action"
              />
            </NavLink>
            <NavLink to="/protocols/winemaking/pre">
              <Button
                isRed={true}
                isFull={true}
                isNavLink={true}
                label={getLabel("protocolsWinemakingNavLink")}
                disableIcon={true}
                isActive={location.pathname === "/protocols/winemaking/pre"}
                customClassName="burger_container_action"
              />
            </NavLink>
            <NavLink to="/protocols/winemaking/post">
              <Button
                isRed={true}
                isFull={true}
                isNavLink={true}
                label={getLabel("protocolsPostWinemakingNavLink")}
                disableIcon={true}
                isActive={location.pathname === "/protocols/winemaking/post"}
                customClassName="burger_container_action"
              />
            </NavLink>
            <NavLink to="/protocols/winemaking/cip">
              <Button
                isRed={true}
                isFull={true}
                isNavLink={true}
                label={getLabel("protocolsCIPWinemakingNavLink")}
                disableIcon={true}
                isActive={location.pathname === "/protocols/winemaking/cip"}
                customClassName="burger_container_action"
              />
            </NavLink>
          </div>}
        </div>}
      </div>
    </div>
  </>);
};

const SideBar = ({ isMobile, isIcon, setIsIcon }) => {
  const location = useLocation();
  const axiosPrivate = useAxiosPrivate();
  const dispatch = useDispatch();
  const [getLabel] = useLabels();
  const user = useSelector(selectUser);
  const users = useSelector(selectUsers);
  const [permission, setPermissions] = useState({});
  const [burgerMenu, toggleBurgerMenu] = useState(false);
  const [secondaryBurgerMenu, toggleSecondaryBurgerMenu] = useState(false);

  useEffect(() => {
    if (!users || users.length === 0) {
        loadUsers();
    }

    const currentUser = user?.role < 3 ? 
      { settings: {permissions: {lots: true, tanks: true, protocols: true, wineries: true, report: true }} } :
      users?.find((u) => u?.username === user?.userName);
    setPermissions(currentUser?.settings?.permissions || {})
  }, [user, users])

  const loadUsers = async () => {
    const currentUsers = await getUsers(axiosPrivate);
    dispatch(setUsers(currentUsers))
  }

  const setIsOpen = (value) => {
    toggleBurgerMenu(value);
  }

  const setIsSecondaryOpen = (value) => {
    toggleSecondaryBurgerMenu(value);
  }

  const renderPrimaryNav = () => (
    <div className="sidebar_container_primary">
      <NavLink to="/">
        <Button
          isRed={true}
          isFull={true}
          label={isIcon ? "" : getLabel("homeNavLink")}
          customClassName={`sidebar_container_action ${isIcon ? "icon" : ""}`}
          isNavLink={true}
          isActive={location.pathname === "/"}
          customIcon={isIcon && home_img}
          disableIcon={!isIcon}
          isLottie={false}
        />
      </NavLink>
      <NavLink to="/programming">
        <Button
          isRed={true}
          isFull={true}
          label={isIcon ? "" : getLabel("programmingNavLink")}
          customClassName={`sidebar_container_action ${isIcon ? "icon" : ""}`}
          isNavLink={true}
          isActive={location.pathname === "/programming"}
          customIcon={isIcon && programming_img}
          disableIcon={!isIcon}
          isLottie={false}
        />
      </NavLink>
      {permission?.lots && <NavLink to="/lots">
        <Button
          isRed={true}
          isFull={true}
          label={isIcon ? "" : getLabel("lotsNavLink")}
          customClassName={`sidebar_container_action ${isIcon ? "icon" : ""}`}
          isNavLink={true}
          isActive={location.pathname === "/lots"}
          customIcon={isIcon && grape_img}
          disableIcon={!isIcon}
          isLottie={false}
        />
      </NavLink>}
      {permission?.tanks && <NavLink to="/tanks">
        <Button
          isRed={true}
          isFull={true}
          label={isIcon ? "" : getLabel("tanksNavLink")}
          customClassName={`sidebar_container_action ${isIcon ? "icon" : ""}`}
          disableIcon={!isIcon}
          isNavLink={true}
          isActive={location.pathname === "/tanks"}
          customIcon={isIcon && tank_img}
          isLottie={false}
        />
      </NavLink>}
      {permission?.protocols && <div
        className="sidebar_container_secondary dropdown"
        // style={{ marginTop: "32px" }}
      >
        <Button
          isRed={true}
          isFull={true}
          isNavLink={true}
          label={isIcon ? "" : getLabel("protocolsNavLink")}
          isActive={location.pathname === "/protocols/analysis"}
          customClassName={`sidebar_container_action ${isIcon ? "icon" : ""}`}
          customIcon={isIcon && protocol_img}
          disableIcon={!isIcon}
          isLottie={false}
        />
        <div className={`dropdown-content downward ${isIcon ? "icon" : ""}`}>
          <NavLink to="/protocols/analysis">
            <Button
              isRed={true}
              isFull={true}
              isNavLink={true}
              label={isIcon ? "" : getLabel("protocolsAnalysisNavLink")}
              isActive={location.pathname === "/protocols/analysis"}
              customClassName={`sidebar_container_action ${isIcon ? "icon" : ""}`}
              customIcon={isIcon && analysis_img}
              disableIcon={!isIcon}
              isLottie={false}
            />
          </NavLink>
          <NavLink to="/protocols/treatment">
            <Button
              isRed={true}
              isFull={true}
              isNavLink={true}
              label={isIcon ? "" : getLabel("protocolsTreatmentNavLink")}
              isActive={location.pathname === "/protocols/treatment"}
              customClassName={`sidebar_container_action ${isIcon ? "icon" : ""}`}
              customIcon={isIcon && treatment_img}
              disableIcon={!isIcon}
              isLottie={false}
            />
          </NavLink>
          <NavLink to="/protocols/winemaking/pre">
            <Button
              isRed={true}
              isFull={true}
              isNavLink={true}
              label={isIcon ? "" : getLabel("protocolsWinemakingNavLink")}
              isActive={location.pathname === "/protocols/winemaking/pre"}
              customClassName={`sidebar_container_action ${isIcon ? "icon" : ""}`}
              customIcon={isIcon && treatment_img}
              disableIcon={!isIcon}
              isLottie={false}
            />
          </NavLink>
          <NavLink to="/protocols/winemaking/post">
            <Button
              isRed={true}
              isFull={true}
              isNavLink={true}
              label={isIcon ? "" : getLabel("protocolsPostWinemakingNavLink")}
              isActive={location.pathname === "/protocols/winemaking/post"}
              customClassName={`sidebar_container_action ${isIcon ? "icon" : ""}`}
              customIcon={isIcon && treatment_img}
              disableIcon={!isIcon}
              isLottie={false}
            />
          </NavLink>
          <NavLink to="/protocols/winemaking/cip">
            <Button
              isRed={true}
              isFull={true}
              isNavLink={true}
              label={isIcon ? "" : getLabel("protocolsCIPWinemakingNavLink")}
              isActive={location.pathname === "/protocols/winemaking/cip"}
              customClassName={`sidebar_container_action ${isIcon ? "icon" : ""}`}
              customIcon={isIcon && treatment_img}
              disableIcon={!isIcon}
              isLottie={false}
            />
          </NavLink>
        </div>
      </div>}
    </div>
  );

  const renderPrimaryNavAdmin = () => (
    <div className="sidebar_container_primary">
      <NavLink to="/clients">
        <Button
          isRed={true}
          isFull={true}
          label={getLabel("clientsNavLink")}
          customClassName={`sidebar_container_action ${isIcon ? "icon" : ""}`}
          isNavLink={true}
          isActive={location.pathname === "/clients"}
          disableIcon={!isIcon}
        />
      </NavLink>
    </div>
  );

  const renderSecondary = () => (
    <div className="sidebar_container_secondary">
      {permission?.warehouse || true && <div
        className="sidebar_container_secondary dropdown"
        // style={{ marginTop: "32px" }}
      >
        <Button
          isRed={true}
          isFull={true}
          isNavLink={true}
          label={isIcon ? "" : getLabel("warehouseNavLink")}
          isActive={location.pathname === "/warehouse"}
          customClassName={`sidebar_container_action ${isIcon ? "icon" : ""}`}
          customIcon={isIcon && pressing_img}
          disableIcon={!isIcon}
          isLottie={false}
        />
        <div className="dropdown-content upward">
          <NavLink to="/warehouse/treatments">
            <Button
              isRed={true}
              isFull={true}
              isNavLink={true}
              label={getLabel("warehouseTreatmentNavLink")}
              disableIcon={true}
              isActive={location.pathname === "/warehouse/treatments"}
              customClassName="sidebar_container_action"
            />
          </NavLink>
          {/* <NavLink to="/warehouse/stock">
            <Button
              isRed={true}
              isFull={true}
              isNavLink={true}
              label={getLabel("warehouseStockNavLink")}
              disableIcon={true}
              isActive={location.pathname === "/warehouse/stock"}
              customClassName="sidebar_container_action"
            /> 
          </NavLink>*/}
          <NavLink to="/warehouse/filters">
            <Button
              isRed={true}
              isFull={true}
              isNavLink={true}
              label={getLabel("warehouseFiltersNavLink")}
              disableIcon={true}
              isActive={location.pathname === "/warehouse/filters"}
              customClassName="sidebar_container_action"
            />
          </NavLink>
          <NavLink to="/warehouse/caps">
            <Button
              isRed={true}
              isFull={true}
              isNavLink={true}
              label={getLabel("warehouseCapsNavLink")}
              disableIcon={true}
              isActive={location.pathname === "/warehouse/caps"}
              customClassName="sidebar_container_action"
            />
          </NavLink>
          <NavLink to="/warehouse/bottles">
            <Button
              isRed={true}
              isFull={true}
              isNavLink={true}
              label={getLabel("warehouseBottlesNavLink")}
              disableIcon={true}
              isActive={location.pathname === "/warehouse/bottles"}
              customClassName="sidebar_container_action"
            />
          </NavLink>
          <NavLink to="/warehouse/machineries">
            <Button
              isRed={true}
              isFull={true}
              isNavLink={true}
              label={getLabel("warehouseMachineriesNavLink")}
              disableIcon={true}
              isActive={location.pathname === "/warehouse/machineries"}
              customClassName="sidebar_container_action"
            />
          </NavLink>
        </div>
      </div>}
      {permission?.report && <div>
        <NavLink to="/report">
          <Button
            isRed={true}
            isFull={true}
            isNavLink={true}
            label={isIcon ? "" : getLabel("reportNavLink")}
            isActive={location.pathname === "/report"}
            customClassName={`sidebar_container_action ${isIcon ? "icon" : ""}`}
            customIcon={isIcon && report_img}
            disableIcon={!isIcon}
            isLottie={false}
          />
        </NavLink>
      </div>}
      {/* <NavLink to="/warehouse">
        <Button
          isRed={true}
          isFull={true}
          label={getLabel("warehouseNavLink")}
          customClassName="sidebar_container_action"
          isNavLink={true}
          isActive={location.pathname === "/warehouse"}
          // customIcon={json_home}
          disableIcon={true}
        />
      </NavLink> */}
      {permission?.wineries && <div>
        <NavLink to="/wineries">
          <Button
            isRed={true}
            isFull={true}
            isNavLink={true}
            label={isIcon ? "" : getLabel("wineriesNavLink")}
            isActive={location.pathname === "/wineries"}
            customClassName={`sidebar_container_action ${isIcon ? "icon" : ""}`}
            customIcon={isIcon && winery_img}
            disableIcon={!isIcon}
            isLottie={false}
          />
        </NavLink>
      </div>}
    </div>
  );

  const handleBurgerMenu = () => {
    if (!burgerMenu && secondaryBurgerMenu) {
      toggleBurgerMenu(true);
      toggleSecondaryBurgerMenu(false);
      return;
    } else if (secondaryBurgerMenu) {
      toggleSecondaryBurgerMenu(false);
      return;
    }

    toggleBurgerMenu(true);
  }

  if (isMobile) {
    return (<>
      <div className="top_burger_bar" onClick={() => burgerMenu && toggleBurgerMenu(false)} >
      {/* onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd} */}
        <div className="bars" onClick={() => handleBurgerMenu()}>
          <FontAwesomeIcon icon={(burgerMenu && secondaryBurgerMenu) ? "fa-arrow-left" : !burgerMenu ? "fa-bars" : "fa-xmark"} size={"2x"} />
        </div>
      </div>
        <BurgerMenu setIsOpen={setIsOpen} isOpen={burgerMenu} setIsSecondaryOpen={setIsSecondaryOpen} isSecondaryOpen={secondaryBurgerMenu} />
      </>
    );
  }

  const handleSidebarIcons = () => {
    const newValue = !isIcon;

    setItem("sidebar_icon", newValue);
    setIsIcon(newValue);
  };

  return (
    <aside className={`sidebar_container ${isIcon ? "icons" : ""}`}>
      {/* {window.navigation && <NavigationButtons />} */}
      {user?.role === 1 ? renderPrimaryNavAdmin() : renderPrimaryNav()}
      {user?.role > 1 && user?.type !== "TANK" && renderSecondary()}
      {!isMobile && <div className={`show_icons ${isIcon ? "open" : ""}`} onClick={handleSidebarIcons}>
        <CTA>
          <FontAwesomeIcon icon="fa-sort-up" />
        </CTA>
      </div>}
      
    </aside>
  );
};

export default SideBar;
